import React, { useEffect, useState } from "react";
import { BeforeInstallPromptEvent } from "../../Interfaces/IGlobal";
import "./PwaInstallPrompt.css";

const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();

      // Check if the user already dismissed
      if (localStorage.getItem("installPromptDismissed") === "true") {
        console.log("User has dismissed the install prompt before.");
        return;
      }

      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("PWA installation accepted");
      } else {
        console.log("PWA installation dismissed");
      }
      setDeferredPrompt(null);
      setShowPrompt(false);
    }
  };

  const handleCancelClick = () => {
    const expirationTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
    console.log("User canceled the prompt");
    localStorage.setItem("installPromptDismissed", expirationTime.toString()); // Save dismissal
    setShowPrompt(false);
  };

  const isPromptDismissed = () => {
    const expirationTime = localStorage.getItem("installPromptDismissed");
    return expirationTime && Date.now() < parseInt(expirationTime, 10);
  };

  return (
    <>
      {showPrompt ||
        (isPromptDismissed() && (
          <div className="popUpWrapper">
            <div className="containerPWA">
              <h2>Installer l'application</h2>
              <p>Installez cette application pour une meilleure expérience.</p>
              <div className="containerButton">
                <button onClick={handleInstallClick}>Installer</button>
                <button className="cancel" onClick={handleCancelClick}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default PwaInstallPrompt;
